import { Injectable } from '@angular/core';
import { AttrIndexService } from './attr-index.service';
import { NagService } from './nag.service';
import { UserService } from './user.service';
import { CommonFunctionService } from './common-function.service';

export interface AgencyCounty {
	// prop: string;
	name: string;
	// isNeighbor?: boolean;
	centroidStr: string;
}

export interface NguidPattern {
	layerType?: boolean;
}
export interface GivCustomerInitInfo {
	bdryName?: string;
	bdryCate?: string;
	county?: { name: string; centroidStr: string }
	// centroidLatlong?: string;
	discrepancyAgencyId?: string;
	nguidPattern: NguidPattern;
	// neighboringCounties: any[];
}

@Injectable({
  providedIn: 'root'
})
export class AgencyInfoService {

	givBdryCateList = [{
		prop: 'COUNTY',
		name: 'COUNTY'
	}, {
		prop: 'REGION',
		name: 'REGION'
	}];
  	constructor(
		private attrIndexService: AttrIndexService,
		private commonService: CommonFunctionService,
		private nagService: NagService,
		private userService: UserService
	) { }

	// getIsLayerTypeFromNguidPattern(patterNum: number) {
	// 	return patterNum === 2 ? true : false
	// }
	async getCounties() {
		const stateCode = this.userService.customerInfo.givState;
		const countiesRsp = await this.nagService.getNagNamesStandard(2, stateCode, null, { pageNumber: 0 });
		if (countiesRsp.data) {
			const countyList = countiesRsp.data.map(i => {
				return {
					name: i[this.attrIndexService.stnNameCol],
					centroidStr: i[this.attrIndexService.centroidCol],
					stnId: i[this.attrIndexService.stnIdCol]
				}
			});
			return countyList;
		} else {
			return [];
		}
	}

	computeNguid(cateCode?: string, globalId?: string, nguidPattern?: NguidPattern) {
		nguidPattern = nguidPattern || this.userService.customerInfo.nguidPattern;
		const part1 = 'urn:emergency:uri:';
		const part2 = cateCode + ':';
		const part3 = (globalId || this.commonService.getRandomId()) + ':';
		const part4 = this.userService.customerInfo.discrepancyId;
		const nguid = nguidPattern.layerType ? part1 + part2 + part3 + part4 : part1 + part3 + part4;
		return nguid;
	}
}
